// extracted by mini-css-extract-plugin
module.exports = {"link":"Link_link__N_GWc","light":"Link_light__3Mfpt","padLeft":"Link_padLeft__1C2Mg","inline":"Link_inline__2kKRU","plain":"Link_plain__3la9_"};